export default{
    section:'بخش',
    uterusAdenomyosisTestsTitle: 'Title',
    sectionStatus: 'Status',
    uterusAdenomyosisTests:'uterus Adenomyosis Tests',
    editUterusAdenomyosisTests:'Edit Uterus Adenomyosis Tests',
    addUterusAdenomyosisTests:'New Uterus Adenomyosis Tests',
}